import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProductState {
  products: any[];
  product: any;
  categories: any[];
  subCategories: any[];
  isLoading: boolean;
}

const PRODUCT_INITIAL: ProductState = {
  products: [],
  product: {},
  categories: [],
  subCategories: [],
  isLoading: false,
};

const productSlice = createSlice({
  name: "product",
  initialState: {
    ...PRODUCT_INITIAL,
  },
  reducers: {
    PRODUCT_UPDATE: (
      state,
      action: PayloadAction<{
        data?: any;
        prop?: string;
        value?: string | Number | Object;
      }>,
    ) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? { [action.payload.prop]: action.payload.value } : null),
      });
    },
  },
});

const { PRODUCT_UPDATE } = productSlice.actions;

export { productSlice, PRODUCT_INITIAL, PRODUCT_UPDATE };
